module.exports = __webpack_public_path__ + "img/login_gsnd.7fca5f46.svg";